import { render, staticRenderFns } from "./Acceptance.vue?vue&type=template&id=4625bb36"
import script from "./Acceptance.vue?vue&type=script&lang=js"
export * from "./Acceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports